import { RootState } from "../StoreHooks";

export const getAirportCode = (state: RootState) => {
  const { airportCode } = state.airportCode || {};
  return airportCode;
};
